export const Theme = {
	colors: {
		colorOne: '#27272c',
		colorTwo: '#19191c',
	},
}
